import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

const Social = () => {
  return (
    <React.Fragment>
      <section className="contact-social bg-light">
        <Container>
          <Row className="align-items-center">
            <Col lg={4}>
              <ul className="list-inline social mt-4">
                <li className="list-inline-item">
                  <Link to="https://web.facebook.com/braveiconsglobal" className="social-icon">
                    <i className="mdi mdi-facebook"></i>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link to="https://www.instagram.com/braveiconsglobal/" className="social-icon">
                    <i className="mdi mdi-instagram"></i>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link to="https://www.linkedin.com/company/braveiconsglobal/" className="social-icon">
                    <i className="mdi mdi-linkedin"></i>
                  </Link>
                </li>
              
              
              </ul>
            </Col>
            <Col lg={4} className="mt-4">
              <p className="contact-title">
                <i className="pe-7s-call"></i> &nbsp;+234(0)70 664 334 77
              </p>
              <p className="contact-title">
                <i className="pe-7s-call"></i> &nbsp;+1(872) 777 1727
              </p>
            </Col>
            
            <Col lg={4} className="mt-4 text-end">
              <p className="contact-title">
                <i className="pe-7s-mail-open"></i>&nbsp; info@braveiconsglobal.com
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Social;
